require("./components/foreach-polyfil/foreach-polyfil.js"); 

import { toggle } from "./components/toggle/toggle.js";
import { cookiePolicy } from "./components/cookiepolicy/cookiepolicy.js";
import { multilevel } from "./components/multilevel-nav/multilevel-nav.js";
import { windowheight } from "./components/windowheight/windowheight.js";

let setElem = document.querySelectorAll('[data-name="Admin Responsive"] label');

setElem.forEach(function (elem, index) {
    elem.addEventListener('click', () => { 
        console.log('add');
        document.querySelector('body').classList.remove('mobile', 'tablet', 'desktop');
        document.querySelector('body').classList.add(elem.firstChild.value);
    });
});

let CookiesEuBanner = new cookiePolicy();
let Multilevel = new multilevel('.menu, .sub-menu');
let toggleInstance = new toggle( 'data-link', 'data-target', 'active' );
let WindowHeight = new windowheight();

export function main() {    
    return (
        console.log('wpvanillex Started')
    );
}


scrollContainer();
function scrollContainer() {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    if(isIE11) {
        return;
    }

    let y;
    let ey;
    let attr;
    let wh;
    let setElem = document.querySelectorAll('.aniscroll');
    
    setElem.forEach(function (elem, index) {
        elem.classList.add('anipending');
    });

    window.addEventListener('scroll', function (e) {

        attr = document.querySelectorAll('.aniscroll');
        attr.forEach(function (elem, index) {
    
            y = (window.scrollY + window.innerHeight);
            ey = elem.offsetTop;

            if(y > ey) {
                elem.classList.add('aniactive');
            } else {
                if(elem.classList.contains('aniactive')) {
                    elem.classList.remove('aniactive');
                }
            }
        });
    }, { passive: true } );
}

captureHeight('data-height_link', 'data-height_target', 'active' );

function captureHeight(link, target, active) {
    var elems = document.querySelectorAll('[' + link + ']');

    elems.forEach(function (elem, index) {
        ['load','resize'].forEach(  evt => 
            window.addEventListener(evt, () => {
                let tgts = document.querySelectorAll('[data-height_target="' + elem.dataset.height_link + '"]');
                tgts.forEach(function (tgt, index) {
                    tgt.setAttribute('style', 'height:' + parseInt((elem.getBoundingClientRect().height)) + 'px');
                },  { passive: true });
            }, { passive: true })
        );
    });

}

// if ('ResizeObserver' in self) {

//     var ro = new ResizeObserver(function(entries) {

//         var defaultBreakpoints = {XS: 380, SM: 576, MD: 768, LG: 992, XL: 1200, HG: 1520};

//         entries.forEach(function(entry) {
            
//             var breakpoints = entry.target.dataset.breakpoints ?
//                 JSON.parse(entry.target.dataset.breakpoints) :
//                 defaultBreakpoints;

//             Object.keys(breakpoints).forEach(function(breakpoint) {
//             var minWidth = breakpoints[breakpoint];
//                 if (entry.contentRect.width >= minWidth) {
//                     entry.target.classList.add(breakpoint);
//                 } else {
//                     entry.target.classList.remove(breakpoint);
//                 }
//             });
//         });
//     });

//     var elements = document.querySelectorAll('[data-observe-resizes]');

//     for (var element, i = 0; element = elements[i]; i++) {
//         ro.observe(element);
        
//     }

// }
    
let linksav = document.querySelectorAll(".acf_block_back_to_top_button a");

linksav.forEach(function (linkav, index) {
    linkav.addEventListener("click", clickHandlerV);
});

function clickHandlerV(e) {
    e.preventDefault();
    let href = this.getAttribute("href");
    let offsetTop = document.querySelector(href).offsetTop;

    scroll({
        top: offsetTop,
        behavior: "smooth"
    });
}

['load', 'scroll'].forEach(  evt => 

    window.addEventListener(evt, () => {

    let arrs = [];
    let arritem;
    let arritems;
    let heights = [];
    let style;
    let height;
    let elems = document.querySelectorAll('[data-matchheight]');

    if (window.innerWidth > 750) {

        elems.forEach(function (elem, index) {
            if (arrs.includes(elem.dataset.matchheight) === false) arrs.push(elem.dataset.matchheight);
        });

        arrs.forEach(function (arr, index) {
            heights = [];
            arritems = document.querySelectorAll('[data-matchheight="' + arr + '"]');
            arritems.forEach(function (arritem, index) {
                height = arritem.getBoundingClientRect().height;
                if (heights.includes( height ) === false) heights.push( height );
            });

            arritems.forEach(function (arritem, index) {
                if(arritem.getBoundingClientRect().height !== Math.max.apply(Math, heights)) {
                    arritem.style.height = Math.max.apply(Math, heights) + 'px';
                }
            });
        });

    }

}, { passive: true } )

);

scrollHook('navScrollHook', '300');

function scrollHook(elem, pos) {
    let setElem = document.querySelector('body');
     window.addEventListener('scroll', function (e) {

        if(window.scrollY > pos) {
            if(!setElem.classList.contains(elem)) {
                setElem.classList.add(elem);
            }
        } else {
            if(setElem.classList.contains(elem)) {
                setElem.classList.remove(elem);
            }
        }

    }, { passive: true } );
}

// Closest Polyfill
if (window.Element && !Element.prototype.closest) {
    Element.prototype.closest =
    function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i,
            el = this;
        do {
            i = matches.length;
            while (--i >= 0 && matches.item(i) !== el) {};
        } while ((i < 0) && (el = el.parentElement));
        return el;
    };
}

// Gravity Forms Custom Dropdown

let qsas;
let par;

document.addEventListener("DOMContentLoaded", function(event) { 
    qsas = document.querySelectorAll('.chosen-search input');
    qsas.forEach(function (item, index) {
        item.setAttribute('readonly', 'true');
    });
});


let overlay = document.querySelectorAll('.is_overlay');

overlay.forEach(function (item, index) {
    item.addEventListener('click', function() {
        stopVideo( item.parentNode );
    });
});

var stopVideo = function ( element ) {
    var iframe = element.querySelector( 'iframe');
    var video = element.querySelector( 'video' );
    if ( iframe !== null ) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
    }
    if ( video !== null ) {
        video.pause();
    }
};

// schools_list 


// let containers = document.querySelectorAll('.schools_list');

// containers.forEach(function (container, index) {
//     container.querySelector('input').value = 'Hello World';

//       loadJSON('https://iris.local/data/schools.json', response);

//     function response(r) {
//          //console.log(r['schools'][1]);

//          r.map(function(r) {
//              if (r.dinner == "sushi") {
//                 console.log(r);
//              }
//          });
         
//     }

//     window.addEventListener('onChange', function (e) {

//     });

  

//     function loadJSON(filePath, success, error) 
//     { 
//         var xhr = new XMLHttpRequest(); 
//         xhr.onreadystatechange = function() 
//         { 
//             if (xhr.readyState === XMLHttpRequest.DONE) { 
//                 if (xhr.status === 200) { 
//                     if (success) 
//                         success(JSON.parse(xhr.responseText));
//                         console.log('load'); 
//             } else { 
//                 if (error) 
//                     error(xhr); 
//                 } 
//             } 
//         }; 
//         xhr.open("GET", filePath, true); 
//         xhr.send(); 
//     } 

// });

let ccs;
 
document.addEventListener("DOMContentLoaded", function(event) { 
    qsas = document.querySelectorAll('.chosen-results');

    

    ccs = document.querySelectorAll('.gravitydrop.chosen-container-single');

    ccs.forEach(function (item, index) {
        ['keydown'].forEach(  evt => 
            window.addEventListener(evt, (item) => {
                if (item.keyCode == 9) {
                    document.querySelectorAll('.chosen-container-single').forEach(function (item, index) {
                        item.classList.remove('chosen-container-active');
                    });
                    console.log('tab!!');
                } else {
                    item.target.parentNode.classList.add('chosen-container-active');
                }
            })
            
        )
    });

    ccs.forEach(function (item, index) {
        ['click', 'touchstart'].forEach(  evt => 
            window.addEventListener(evt, (item) => {
                if(item.target.classList.contains('chosen-gravitydrop')) {
                    item.target.parentNode.classList.add('chosen-container-active');
                } else if(item.target.classList.contains('active-result')) {
                    if(item.target.closest('.gravitydrop')) {
                        item.target.closest('.gravitydrop').querySelector('input').value = item.target.textContent;
                    }
                } else if(
                    item.target.classList.contains('chosen-search-input') || 
                    item.target.classList.contains('gf_placeholder') ||  
                    item.target.classList.contains('chosen-results') || 
                    item.target.classList.contains('chosen-drop') || 
                    item.target.classList.contains('active-result') || 
                    item.target.classList.contains('chosen-single') ||
                    item.target.classList.contains('chosen-container') 
                ) {
                    
                } else {
                    document.querySelectorAll('.chosen-container-single').forEach(function (item, index) {
                        item.classList.remove('chosen-container-active');
                    });
                    
               
                }
               
            })
        )
    });
    

    qsas.forEach(function (item, index) {

        ['click','touchstart'].forEach(  evt => 
            window.addEventListener(evt, (item) => {

            if(!item.target.classList.contains('gf_placeholder') && item.target.classList.contains('active-result')) {
            

            par = item.target.closest('.chosen-container-single');
            par.classList.remove('chosen-container-active');

         
            }

            })
        );
    });
});



qsas = document.querySelectorAll('.current-menu-item');
var closest = '';

qsas.forEach(function (item, index) {
  

    closest = item.closest('.menu > .menu-item');
    console.log(closest);

    console.log( closest.querySelector('a').classList.add('active') );
});
